import { gql } from '@apollo/client';

const addNFTToFavoriteMutation = gql `
  mutation addNFTToFavourite($orgID: UUID1!, $tokenId: UUID1!) {
    addNFTToFavourite(orgID: $orgID, tokenId: $tokenId)
  }
`;
const removeNFTFromFavoriteMutation = gql `
  mutation removeNFTFromFavourite($orgID: UUID1!, $tokenId: UUID1!) {
    removeNFTFromFavourite(orgID: $orgID, tokenId: $tokenId)
  }
`;
const getNFTFavoriteListByUserQueries = gql `
  query (
    $orgID: UUID1!
    $offset: Int
    $limit: Int
    $searchKey: String
    $filters: SavedNFTFilterInput
    $buyerAddress: String
  ) {
    getNFTFavouriteListByUser(
      orgId: $orgID
      offset: $offset
      limit: $limit
      searchKey: $searchKey
      filter: $filters
      buyerAddress: $buyerAddress
    ) {
      data {
        id
        title
        status
        network
        networkID
        tokenURI
        balance
        nftTokenId
        tokenType
        timeLastUpdated
        description
        mintedAt
        listedAt
        contractAddress
        contractName
        artistName
        favouriteCount
        owner
        mediaSourceURL
        mediaSourceExtension
        latestOffer {
          price {
            value
            unit
            type
          }
        }
        listedOrderInfo {
          id
          listedCurrency {
            contractAddress
          }
          price {
            value
            unit
            type
          }
        }
        isBuyNowEnabled
        isMakeOfferEnabled
        isOfferExist
        price {
          buyNowPrice {
            value
            unit
            type
          }
          lastPurchasedPrice {
            value
            unit
            type
          }
          makeOfferHighestPrice {
            value
            unit
            type
          }
          makeOfferLatestPrice {
            value
            unit
            type
          }
        }
        metadata {
          name
          image
          description
          animationURL
          openSeaImageURL
        }
      }
      totalCount
    }
  }
`;

export { addNFTToFavoriteMutation, getNFTFavoriteListByUserQueries, removeNFTFromFavoriteMutation };
